<template>
  <div class="details-box">
    <el-dialog
      :before-close="handleClose"
      :title="details.title"
      :visible.sync="dialogVisible"
      fullscreen
      width="95%"
    >
      <el-form ref="dataForm" :model="form" :rules="rules" label-width="150px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="填报人姓名：" prop="userName">
              <el-input
                v-model="form.userName"
                :disabled="details.type == 'look'"
                placeholder="请输入姓名"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="填报人手机号：" prop="phone">
              <el-input
                v-model="form.phone"
                :disabled="details.type == 'look'"
                placeholder="请输入手机号"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="承诺书附件：" prop="cnsUrl">
              <el-upload
                v-model="form.cnsUrl"
                :action="$imgHost"
                :before-upload="beforeUploadCnsUrl"
                :disabled="details.type == 'look'"
                :file-list="cnsUrlList"
                :limit="1"
                :on-exceed="handleExceed"
                :on-preview="handlePreviewFj"
                :on-progress="handleprogress"
                :on-remove="handleRemoveCnsUrl"
                :on-success="handleSuccessCnsUrl"
                accept=".png,.jpg,.jpeg,.gif,.pdf"
                class="upload-demo"
              >
                <el-button
                  :disabled="details.type == 'look'"
                  size="small"
                  type="text"
                  >点击上传
                </el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="width: 100%; overflow: auto; height: 440px">
          <table style="table-layout: fixed; width: 1800px">
            <thead>
              <tr>
                <th>一级指标</th>
                <th v-if="zbjbNum > 1">二级指标</th>
                <th v-if="zbjbNum > 2">三级指标</th>
                <th v-if="zbjbNum > 3">四级指标</th>
                <th style="width: 5%">分值</th>
                <th style="width: 200px">评分标准</th>
                <th style="width: 200px">数据来源</th>
                <th style="width: 120px">数据来源类型</th>
                <th style="width: 9%">自评分</th>
                <th style="width: 120px">上传对应资料</th>
                <th v-if="details.type !== 'add'" style="width: 7%">
                  初审得分
                </th>
                <th v-if="details.type !== 'add'" style="width: 7%">
                  初审扣分原因
                </th>
                <th v-if="details.type !== 'add'" style="width: 7%">
                  补充资料
                </th>
                <th v-if="details.type !== 'add'" style="width: 7%">
                  终审得分
                </th>
                <th v-if="details.type !== 'add'" style="width: 7%">
                  终审扣分原因
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(group, index) in form.tableData" :key="index">
                <td
                  v-if="group.zbjb === 1"
                  :colspan="group.colspan"
                  :rowspan="group.rowspan"
                >
                  {{ group.zbTitle }}
                </td>
                <td
                  v-if="group.zbjb === 2"
                  :colspan="group.colspan"
                  :rowspan="group.rowspan"
                >
                  {{ group.zbTitle }}
                </td>
                <td
                  v-if="group.zbjb === 3"
                  :colspan="group.colspan"
                  :rowspan="group.rowspan"
                >
                  {{ group.zbTitle }}
                </td>
                <td v-if="group.zbjb === 4">
                  {{ group.zbTitle }}
                </td>
                <td v-if="group.childrenLength === 0">{{ group.score }}</td>
                <td v-if="group.childrenLength === 0">
                  <el-input
                    v-model="group.pjbz"
                    :rows="4"
                    disabled
                    type="textarea"
                  >
                  </el-input>
                </td>
                <td v-if="group.childrenLength === 0">
                  {{ group.dataSource }}
                </td>
                <td v-if="group.childrenLength === 0">
                  {{
                    group.sourceType != null
                      ? sourceTypeList.find(
                          (item) => item.value === group.sourceType,
                        ).label
                      : group.dataSource
                  }}
                </td>

                <td v-if="group.childrenLength === 0">
                  <el-form-item
                    :prop="'tableData.' + index + '.zpScore'"
                    :rules="rules.zpScore"
                    label-width="0px"
                  >
                    <el-input-number
                      v-model="group.zpScore"
                      :disabled="
                        details.type == 'look' || group.sourceType == 9
                      "
                      :max="group.score"
                      :precision="2"
                      controls-position="right"
                      style="width: 95%"
                      @change="zpScoreChange"
                    ></el-input-number>
                  </el-form-item>
                </td>
                <td v-if="group.childrenLength === 0">
                  <el-form-item
                    :prop="'tableData.' + index + '.fileUrl'"
                    :rules="rules.fileUrl"
                    label-width="0px"
                  >
                    <el-upload
                      v-if="details.type !== 'look' && group.sourceType == 0"
                      v-model="group.fileUrl"
                      :action="$imgHost"
                      :before-upload="beforeUpload.bind(this, group)"
                      :disabled="details.type == 'look'"
                      :file-list="group.fileUrlArr"
                      :limit="1"
                      :on-error="handleError.bind(this, group)"
                      :on-exceed="handleExceed"
                      :on-preview="handlePreview.bind(this, group, 1)"
                      :on-remove="handleRemove.bind(this, group, 1)"
                      :on-success="handleSuccess.bind(this, group, 1)"
                      accept=".png,.jpg,.jpeg,.gif,.pdf,.zip,.7z,.rar"
                      class="upload-demo"
                    >
                      <el-button
                        :disabled="
                          details.type == 'look' ||
                          group.sourceType == 1 ||
                          group.sourceType == 2
                        "
                        size="small"
                        type="text"
                        >点击上传
                      </el-button>
                    </el-upload>
                    <el-button
                      v-if="details.type !== 'look' && group.sourceType == 4"
                      size="small"
                      type="text"
                      @click="multifileModalClick(group, 1)"
                    >
                      <span v-if="group.attachNum > 0"
                        >查看资料({{ group.attachNum }})</span
                      >
                      <span v-else> 点击上传</span>
                    </el-button>
                    <div
                      v-else
                      style="
                        width: 100%;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                      "
                    >
                      <div
                        v-if="group.sourceType == 0 || group.sourceType == 4"
                      >
                        <el-button
                          v-if="group.fileUrl"
                          type="text"
                          @click="lookFileClick(group, 1)"
                        >
                          查看资料
                        </el-button>
                        <el-button
                          v-else-if="group.attachNum > 0"
                          type="text"
                          @click="lookFileClick(group, 1)"
                        >
                          查看资料({{ group.attachNum }})
                        </el-button>
                        <span v-else-if="details.type == 'look'">无</span>
                      </div>
                      <div v-else-if="group.sourceType == 9">无</div>
                      <el-button
                        v-else
                        type="text"
                        @click="lookUserClick(group)"
                      >
                        查看
                      </el-button>
                    </div>
                  </el-form-item>
                </td>
                <td v-if="group.childrenLength === 0 && details.type !== 'add'">
                  {{ group.csScore }}
                </td>
                <td v-if="group.childrenLength === 0 && details.type !== 'add'">
                  {{ group.deductReasonCs }}
                </td>
                <td v-if="group.childrenLength === 0 && details.type !== 'add'">
                  <el-form-item
                    :prop="'tableData.' + index + '.complementFile'"
                    :rules="rules.complementFile"
                    label-width="0px"
                  >
                    <!--                补充资料上传处 2025-02-06修改成多文件上传 -->
                    <el-button
                      v-if="
                        details.typeBczl == 'bczl' && details.data.status == 2
                      "
                      size="small"
                      type="text"
                      @click="multifileModalClick(group, 2)"
                    >
                      <span v-if="group.complementNum > 0"
                        >查看资料({{ group.complementNum }})</span
                      >
                      <span v-else> 点击上传</span>
                    </el-button>
                    <div
                      v-else
                      style="
                        width: 100%;
                        height: 100px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                      "
                    >
                      <div>
                        <el-button
                          v-if="group.complementNum > 0"
                          type="text"
                          @click="lookFileClick(group, 2)"
                        >
                          查看资料({{ group.complementNum || 0 }})
                        </el-button>
                        <span v-else>无</span>
                      </div>
                    </div>
                  </el-form-item>
                </td>
                <td v-if="group.childrenLength === 0 && details.type !== 'add'">
                  {{ group.zsScore }}
                </td>
                <td v-if="group.childrenLength === 0 && details.type !== 'add'">
                  {{ group.deductReasonZs }}
                </td>
              </tr>
              <tr>
                <td
                  :colspan="zbjbNum"
                  style="text-align: right; font-weight: bold"
                >
                  分值汇总：
                </td>
                <td>{{ sumScore }}</td>
                <td :colspan="3" style="text-align: right; font-weight: bold">
                  自评分汇总：
                </td>
                <td :colspan="details.type == 'add' ? 2 : 0">
                  {{ sumZpScore }}
                </td>
                <td
                  v-if="details.type !== 'add'"
                  style="text-align: right; font-weight: bold"
                >
                  初审得分汇总：
                </td>
                <td v-if="details.type !== 'add'">{{ sumCsScore }}</td>
                <td
                  v-if="details.type !== 'add'"
                  :colspan="2"
                  style="text-align: right; font-weight: bold"
                >
                  终审得分汇总：
                </td>
                <td v-if="details.type !== 'add'" colspan="2">
                  {{ sumZsScore }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <el-form-item label-width="0px">
          <el-input :rows="5" :value="details.data.remark" type="textarea">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          v-if="details.type == 'edit' || details.type == 'add'"
          :loading="btnLoading"
          @click="handleSubmit(0)"
        >
          保存草稿
        </el-button>
        <el-button
          v-if="details.type == 'edit' || details.type == 'add'"
          :loading="btnLoading"
          type="primary"
          @click="handleSubmit(1)"
        >
          提交评审
        </el-button>
        <el-button
          v-if="details.typeBczl == 'bczl' && details.data.status == 2"
          :loading="btnLoading"
          type="primary"
          @click="handleBCCLSubmit()"
        >
          保 存
        </el-button>
      </span>
      <el-image
        ref="imgViewRef"
        :height="100"
        :preview-src-list="fileUrlList"
        :preview-teleported="true"
        :src="$previewImg + fileUrl"
        :width="100"
        style="display: none"
      >
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline" style="font-size: 28px"></i>
        </div>
      </el-image>
    </el-dialog>
    <UserModal
      :details="userModalDetails"
      @handleClose="userModalClose"
    ></UserModal>
    <FileModal
      :details="fileModalDetails"
      @handleClose="userModalClose"
    ></FileModal>
    <!--  多文件上传弹窗  -->
    <MultifileUpdate
      ref="multifileModalDetails"
      :details="multifileModalDetails"
      @handleClose="userModalClose"
    ></MultifileUpdate>
  </div>
</template>
<script>
import UserModal from "./userModal.vue";
import FileModal from "./fileModal.vue";
import MultifileUpdate from "./multifileUpdate.vue";
import {
  getTreeTemplateContetsApi,
  saveDeclareRecordApi,
  batchEditDeclareDetailApi,
  getDeclareRecordDetailsApi,
  batchComplatementFileApi,
} from "@/api/home";

export default {
  props: ["details"],
  components: { UserModal, FileModal, MultifileUpdate },
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入填报人中文姓名"));
      }
      if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
        return callback(new Error("姓名必须是中文"));
      }
      callback();
    };

    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入填报人手机号"));
      }
      if (!/^1[3-9]\d{9}$/.test(value)) {
        return callback(new Error("手机号格式不正确"));
      }
      callback();
    };
    return {
      srcList: [],
      dialogVisible: false,
      tableData: [],
      fileList: [],
      xh_userInfo: {},
      idMap: {},
      rules: {
        zpScore: [
          { required: false, message: "请输入自评分", trigger: "blur" },
        ],
        fileUrl: [
          { required: false, message: "请上传资料", trigger: "change" },
        ],
        cnsUrl: [
          { required: true, message: "请上传承诺书资料", trigger: "change" },
        ],
        userName: [
          { validator: validateName, trigger: "blur", required: true },
        ],
        phone: [
          { required: true, message: "请输入填报人手机号", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
      },
      form: {
        tableData: [],
        cnsUrl: "", // 承诺书附件
        cnsName: "", // 承诺书附件名称
        userName: "", // 填报人姓名
        phone: "", // 填报人手机号
      },
      userModalDetails: {
        dialogVisible: false,
        title: "从业人员",
        data: {},
      },
      fileModalDetails: {
        dialogVisible: false,
        title: "查看附件",
        data: {},
      },
      multifileModalDetails: {
        dialogVisible: false,
        title: "资料列表",
        type: "edit",
        data: {},
      },
      fileUrl: "",
      fileUrlList: [],
      zbjbNum: null, // 最大指标等级
      cnsUrlList: [], // 承诺书附件
      btnLoading: false,
      sumScore: 0, // 分值汇总
      sumZpScore: 0, // 自评分汇总
      sumCsScore: 0, // 初审得分汇总
      sumZsScore: 0, // 终审得分汇总
      multiParams: {
        detailId: "",
      },
      sourceTypeList: [
        {
          label: "自主上传",
          value: 0,
        },
        {
          label: "从业人员",
          value: 1,
        },
        {
          label: "项目负责人",
          value: 2,
        },
        {
          label: "课程中心",
          value: 3,
        },
        {
          label: "多文件上传",
          value: 4,
        },
        {
          label: "会员申请缴费记录",
          value: 5,
        },
        {
          label: "无需填报",
          value: 9,
        },
      ],
    };
  },
  watch: {
    details: {
      handler(newValue, oldValue) {
        // 这里不仅可以监听到对象引用的变化，还能监听到对象内部属性的变化
        this.dialogVisible = newValue.dialogVisible;
        this.rules.cnsUrl[0].required = true;
        this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
        this.form.cnsUrl = "";
        this.cnsUrlList = [];
        this.form.userName = "";
        this.form.phone = "";
        if (newValue.type == "add") {
          console.log("details:", newValue);

          this.getById();
        } else if (
          newValue.type == "edit" ||
          newValue.type == "look" ||
          newValue.typeBczl == "bczl"
        ) {
          console.log("details22:", newValue);

          this.getByIds();
          this.form.cnsUrl = newValue.data.cnsUrl;
          this.form.cnsName = newValue.data.cnsName;
          this.form.userName = newValue.data.userName;
          this.form.phone = newValue.data.phone;
          let fileUrl = {
            name: newValue.data.cnsName,
            fileName: newValue.data.cnsName,
            url: newValue.data.cnsUrl,
            fileUrl: newValue.data.cnsUrl,
          };
          this.cnsUrlList = newValue.data.cnsUrl ? [fileUrl] : [];
        }
      },
      deep: true, // 开启深度监听
    },
  },
  mounted() {},
  methods: {
    // 上传的附件查看
    handlePreviewFj(row) {
      this.fileUrl = this.form.cnsUrl;
      let fileUrlList = [];
      fileUrlList.push(this.$previewImg + this.fileUrl);
      this.fileUrlList = fileUrlList;
      this.$refs.imgViewRef.showViewer = true; // 打开预览
    },
    handleClose() {
      this.$emit("handleClose");
    },
    // 保存草稿，提交初审
    handleSubmit(saveType) {
      console.log("tableData", this.form.tableData);
      if (saveType === 0) {
        // 保存草稿不校验承诺书附件 cnsUrl
        this.rules.cnsUrl[0].required = false;
      } else {
        // 提交初审校验承诺书附件 cnsUrl
        this.rules.cnsUrl[0].required = true;
      }
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          if (this.details.type == "add") {
            let parmaArr = [];
            this.form.tableData.forEach((item, index) => {
              if (item.childrenLength == 0) {
                parmaArr.push({
                  attachNum: item.attachNum || 0,
                  complementNum: item.complementNum || 0,
                  contentId: item.id,
                  zpScore: item.zpScore || "",
                  fileUrl: item.fileUrl || "",
                  fileName: item.fileName || "",
                  complementFile: item.complementFile || "",
                  complementFileName: item.complementFileName || "",
                  mutilpartFiles: item.mutilpartFiles || [],
                  mutilpartBcFiles: item.mutilpartBcFiles || [],
                });
              }
            });
            let params = {
              templateId: this.details.data.id,
              saveType: saveType,
              declareDetails: parmaArr,
              cnsUrl: this.form.cnsUrl,
              cnsName: this.form.cnsName,
              userName: this.form.userName,
              phone: this.form.phone,
            };
            saveDeclareRecordApi(params).then((res) => {
              this.btnLoading = false;
              this.$emit("handleClose");
            });
          }
          if (this.details.type == "edit") {
            let parmaArr = [];
            this.form.tableData.forEach((item, index) => {
              if (item.childrenLength == 0) {
                parmaArr.push({
                  id: item.declareDetailId,
                  attachNum: item.attachNum || 0,
                  complementNum: item.complementNum || 0,
                  zpScore: item.zpScore || "",
                  fileUrl: item.fileUrl || "",
                  fileName: item.fileName || "",
                  complementFile: item.complementFile || "",
                  complementFileName: item.complementFileName || "",
                  mutilpartFiles: item.mutilpartFiles || [],
                  mutilpartBcFiles: item.mutilpartBcFiles || [],
                });
              }
            });
            let params = {
              declareId: this.details.data.id,
              saveType: saveType,
              declareDetails: parmaArr,
              cnsUrl: this.form.cnsUrl,
              cnsName: this.form.cnsName,
              userName: this.form.userName,
              phone: this.form.phone,
            };
            batchEditDeclareDetailApi(params).then((res) => {
              this.btnLoading = false;
              this.$emit("handleClose");
            });
          }
        } else {
          console.log("验证失败");
          return false;
        }
      });
    },
    // 补充材料保存接口
    handleBCCLSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          let parmaArr = [];
          this.form.tableData.forEach((item, index) => {
            if (item.childrenLength == 0) {
              parmaArr.push({
                id: item.declareDetailId,
                zpScore: item.zpScore || "",
                fileUrl: item.fileUrl || "",
                fileName: item.fileName || "",
                complementFile: item.complementFile || "",
                complementNum: item.complementNum || 0,
                complementFileName: item.complementFileName || "",
                mutilpartBcFiles: item.mutilpartBcFiles || [],
              });
            }
          });
          let params = {
            declareId: this.details.data.id,
            declareDetails: parmaArr,
          };
          batchComplatementFileApi(params).then((res) => {
            this.btnLoading = false;
            this.$emit("handleClose");
          });
        } else {
          console.log("验证失败");
          return false;
        }
      });
    },
    getById() {
      // 立即申报 查询模版数据
      getTreeTemplateContetsApi({
        templateId: this.details.data.id,
        token: this.xh_userInfo.token,
      }).then((res) => {
        if (res.code == 200) {
          if (Array.isArray(res.result) && res.result.length > 0) {
            let dataArr = res.result.map((item) => {
              item.isEdit = false;

              if (item.sourceType === 4) {
                item.attachNum = 0;
                item.complementNum = 0;
                // 多文件
                item.mutilpartFiles = [];
                item.mutilpartBcFiles = [];
              }
              return item;
            });
            this.form.tableData = dataArr;
            console.log("this.form.tableData", this.form.tableData);
            this.idMap = new Map(
              this.form.tableData.map((item) => [item.id, item]),
            );
            console.log("idMap", this.idMap);
            // 获取指标最大等级
            this.zbjbNum = this.form.tableData.reduce((max, obj) => {
              return Math.max(max, obj["zbjb"]);
            }, -Infinity);
            console.log("zbjbNum最大等级", this.zbjbNum);
            this.scoreSum();
            // let sumScoreNew = 0;
            // let sumZpScoreNew = 0;
            // let sumCsScoreNew = 0;
            // let sumZsScoreNew = 0;
            // // 遍历数组并更新每个元素
            // this.form.tableData.forEach((item) => {
            //   item.childrenLength = this.countChildren(item.id); // 调用递归函数并更新childrenLength
            //   if (item.childrenLength === 0) {
            //     sumScoreNew += item.score || 0;
            //     sumZpScoreNew += item.zpScore || 0;
            //     sumCsScoreNew += item.csScore || 0;
            //     sumZsScoreNew += item.zsScore || 0;
            //   }
            //   item.rowspan = this.countChildren(item.id)
            //     ? this.countChildren(item.id) + 1
            //     : 0;
            //   if (item.zbjb === 1 && item.childrenLength === 0) {
            //     // item.colspan = 4;
            //     item.rowspan = 1;
            //     item.colspan = this.zbjbNum;
            //   }
            //   if (item.zbjb === 2 && item.childrenLength === 0) {
            //     // item.colspan = 3;
            //     item.rowspan = 1;
            //     item.colspan = this.zbjbNum - 1;
            //   }
            //   if (item.zbjb === 3 && item.childrenLength === 0) {
            //     // item.colspan = 2;
            //     item.rowspan = 1;
            //     item.colspan = this.zbjbNum == 4 ? 2 : 1;
            //   }
            // });
            // this.sumScore = sumScoreNew;
            // this.sumZpScore = sumZpScoreNew;
            // this.sumCsScore = sumCsScoreNew;
            // this.sumZsScore = sumZsScoreNew;
            console.log("getById.result", this.form.tableData);
          }
        }
      });
    },

    getByIds() {
      // 修改资料 查询模版数据
      getDeclareRecordDetailsApi({
        declareId: this.details.data.id,
        token: this.xh_userInfo.token,
      }).then((res) => {
        if (res.code == 200) {
          console.log("res.result", res.result);
          if (Array.isArray(res.result) && res.result.length > 0) {
            let dataArr = res.result.map((item) => {
              item.isEdit = false;
              item.fileUrlArr = item.fileUrl
                ? [
                    {
                      name: item.fileName,
                      url: this.$previewImg + item.fileUrl,
                    },
                  ]
                : [];
              item.complementFileArr = item.complementFile
                ? [
                    {
                      name: item.complementFileName,
                      url: this.$previewImg + item.complementFile,
                    },
                  ]
                : [];
              if (item.fileUrl) {
                this.srcList.push(this.$previewImg + item.fileUrl);
              }
              if (item.zpScore == null) {
                item.zpScore = undefined;
              }
              if (item.sourceType === 4) {
              }
              // 多文件
              item.mutilpartFiles = [];
              item.mutilpartBcFiles = [];
              return item;
            });
            this.form.tableData = dataArr;
            this.idMap = new Map(
              this.form.tableData.map((item) => [item.id, item]),
            );
            console.log("idMap", this.idMap);
            // 获取指标最大等级
            this.zbjbNum = this.form.tableData.reduce((max, obj) => {
              return Math.max(max, obj["zbjb"]);
            }, -Infinity);
            console.log("zbjbNum最大等级", this.zbjbNum);
            this.scoreSum();

            console.log("getByIds.result", this.form.tableData);
          }
        }
      });
    },
    countChildren(id) {
      let count = 0;
      this.form.tableData.forEach((item) => {
        if (item.parentId === id) {
          count++;
          count += this.countChildren(item.id); // 递归计算子节点的子节点
        }
      });
      return count;
    },
    zpScoreChange() {
      // let sumScoreNew = 0;
      // let sumZpScoreNew = 0;
      // // 遍历数组并更新每个元素
      // this.form.tableData.forEach((item) => {
      //   sumScoreNew += item.score || 0;
      //   sumZpScoreNew += item.zpScore || 0;
      // });
      // this.sumScore = sumScoreNew;
      // this.sumZpScore = sumZpScoreNew;
      this.scoreSum();
      console.log("this.sumZpScore", this.sumZpScore);
    },
    // 分数汇总
    scoreSum() {
      let sumScoreNew = 0;
      let sumZpScoreNew = 0;
      let sumCsScoreNew = 0;
      let sumZsScoreNew = 0;
      // 遍历数组并更新每个元素
      this.form.tableData.forEach((item) => {
        item.childrenLength = this.countChildren(item.id); // 调用递归函数并更新childrenLength
        if (item.childrenLength === 0) {
          sumScoreNew += item.score || 0;
          sumZpScoreNew += item.zpScore || 0;
          sumCsScoreNew += item.csScore || 0;
          sumZsScoreNew += item.zsScore || 0;
        }
        item.rowspan = this.countChildren(item.id)
          ? this.countChildren(item.id) + 1
          : 0;
        if (item.zbjb === 1 && item.childrenLength === 0) {
          // item.colspan = 4;
          item.rowspan = 1;
          item.colspan = this.zbjbNum;
        }
        if (item.zbjb === 2 && item.childrenLength === 0) {
          // item.colspan = 3;
          item.rowspan = 1;
          item.colspan = this.zbjbNum - 1;
        }
        if (item.zbjb === 3 && item.childrenLength === 0) {
          // item.colspan = 2;
          item.rowspan = 1;
          item.colspan = this.zbjbNum == 4 ? 2 : 1;
        }
      });
      this.sumScore = sumScoreNew;
      this.sumZpScore = sumZpScoreNew;
      this.sumCsScore = sumCsScoreNew;
      this.sumZsScore = sumZsScoreNew;
    },
    // 上传文件之前的钩子
    beforeUpload(row, file) {
      console.log("beforeUpload", row);
      console.log("beforeUpload", file);
      const { uid, name, size } = file;
      this.multiParams.detailId = row.id;
      console.log(uid, name, size);
      const fileTypeFlag =
        /^.png|.jpg|.jpeg|.gif|.pdf|.zip|.7z|.rar|.gz|.tar$/.test(
          name.substring(name.lastIndexOf(".")).toLowerCase(),
        );
      if (!fileTypeFlag) {
        this.$message({
          message:
            "文件类型只能是.png|.jpg|.jpeg|.gif|.pdf|.zip|.7z|.rar|.gz|.tar",
          type: "warning",
          duration: "5000",
        });
        row.fileUrlArr = [];
        return false;
      }
      // 文件大小限制
      if (size > 1024 * 1024 * 100) {
        this.$message.warning("文件大小不能超过100Mb");
        return false;
      }
    },
    beforeUploadCnsUrl(file) {
      console.log("beforeUploadCnsUrl", file);
      const { uid, name, size } = file;
      // console.log(uid, name, size);
      //   文件类型限制
      const fileTypeFlag = /^.png|.jpg|.jpeg|.gif|.pdf$/.test(
        name.substring(name.lastIndexOf(".")).toLowerCase(),
      );
      if (!fileTypeFlag) {
        this.$message({
          message: "文件类型只能是.png|.jpg|.jpeg|.gif|.pdf",
          type: "warning",
          duration: "5000",
        });
        // this.cnsUrlList = [];
        return false;
      }
      // 文件大小限制
      if (size > 1024 * 1024 * 100) {
        this.$message.warning("文件大小不能超过100Mb");
        return false;
      }
    },
    // 承诺书附件 删除
    handleRemoveCnsUrl(file) {
      this.form.cnsUrl = "";
      this.form.cnsName = "";
      this.cnsUrlList = [];
    },
    // 承诺书附件 上传成功
    handleSuccessCnsUrl(response, file) {
      console.log("file", file.response);

      if (file.response.code == 200) {
        this.form.cnsUrl = response.result.file.filefullpath;
        this.form.cnsName = file.name;
        console.log("response", response.result.file);
        console.log("file", file);
      } else {
        this.form.cnsUrl = "";
        this.form.cnsName = "";
        this.cnsUrlList = [];
      }
    },
    // 文件列表移除文件时的钩子
    handleRemove(row, file, fileList) {
      row.fileUrl = "";
      console.log("handleRemove", file, fileList);
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    // 文件上传成功时的钩子
    handleSuccess(scope, type, response, file) {
      // type:1对应资料,2:补充资料
      console.log("scope---", scope);
      console.log("type", type);
      console.log("response", response);
      console.log("file", file);
      if (response.code == 200) {
        if (type == 1) {
          scope.fileUrl = response.result.file.filefullpath;
          scope.fileName = file.name;
        }
        if (type == 2) {
          scope.complementFile = response.result.file.filefullpath;
          scope.complementFileName = file.name;
        }
        if (type == 3) {
          scope.mutilpartFiles.push(response.result[0]);
          console.log("scope.mutilpartFiles", scope.mutilpartFiles);
        }
      } else {
        this.$message.error(response.message);
        if (type == 1) {
          scope.fileUrlArr = [];
        }
        if (type == 2) {
          scope.complementFileArr = [];
        }
      }
    },
    handleError(scope, err, file, fileList) {},
    handlePreview(row, type) {
      // type:1对应资料,2:补充资料
      this.lookFileClick(row, type);
    },
    handleprogress(event, file) {
      console.log("event", event);
    },
    // 查看从业人员、项目负责人
    lookUserClick(group) {
      this.userModalDetails.dialogVisible = true;
      this.userModalDetails.title =
        group.sourceType != null
          ? this.sourceTypeList.find((it) => it.value == group.sourceType).label
          : "";
      this.userModalDetails.data = group;
    },
    // 多文件上传 弹窗
    multifileModalClick(group, type) {
      this.$refs.multifileModalDetails.fileType = type;
      this.multifileModalDetails.dialogVisible = true;
      this.multifileModalDetails.type = "edit";
      this.multifileModalDetails.data = group;
    },
    // 查看从业人员、项目负责人 弹窗关闭
    userModalClose(num) {
      console.log("userModalClose关闭", this.form.tableData);
      this.userModalDetails.dialogVisible = false;
      this.fileModalDetails.dialogVisible = false;
      this.multifileModalDetails.dialogVisible = false;
    },
    lookFileClick(group, type) {
      console.log(group, "typeeeeeeee", type);
      if ((type && type == 2) || (type == 1 && group.sourceType == 4)) {
        // 多文件
        this.multifileModalDetails.dialogVisible = true;
        this.multifileModalDetails.type = "look";
        this.multifileModalDetails.data = group;
        this.$refs.multifileModalDetails.fileType = type;
        return;
      }
      // type:1对应资料,2:补充资料
      // 查看附件
      let fileName =
        type == 1
          ? group.fileName
          : type == 2
            ? group.complementFileName
            : group.fileName;
      let fileUrl =
        type == 1
          ? group.fileUrl
          : type == 2
            ? group.complementFile
            : group.fileUrl;

      const extension = fileName.split(".").pop().toLowerCase();
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
      const pdfExtension = "pdf";
      const zipExtensions = ["zip", "rar", "7z", "gz", "tar"];
      if (imageExtensions.includes(extension)) {
        // img
        this.fileUrl = this.$previewImg + fileUrl;
        let fileUrlList = [];
        fileUrlList.push(this.$previewImg + fileUrl);
        this.fileUrlList = fileUrlList;
        this.$refs.imgViewRef.showViewer = true; // 打开预览
      } else if (extension === pdfExtension) {
        // pdf
        this.fileModalDetails.dialogVisible = true;
        console.log("group", group);
        this.fileModalDetails.data = group;
      } else if (zipExtensions.includes(extension)) {
        // 压缩包
        window.location.href = `${this.$previewImg + fileUrl}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details-box {
  table {
    width: 1200px; /* 表格宽度 */
    border-collapse: collapse; /* 边框合并为一个单一的边框 */
    margin: 20px 0; /* 上下外边距 */
    overflow-y: auto;
  }

  th,
  td {
    border: 1px solid #ddd; /* 单元格边框 */
    padding: 8px; /* 单元格内边距 */
    text-align: left; /* 文本左对齐 */
  }

  th {
    background-color: #f2f2f2; /* 表头背景色 */
    color: #333; /* 表头文字颜色 */
  }

  ///deep/ .el-table .warning-row {
  //  background: oldlace;
  //}
  ///deep/ .el-table .success-row {
  //  background: #f0f9eb;
  //}
  ///deep/ .el-table .success-row1 {
  //  background: #d2f3ff;
  //}
  /deep/ .el-image .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    background: #f5f7fa;
    color: #909399;
  }
}
</style>
